import { faExclamationCircle } from "@fortawesome/pro-duotone-svg-icons";
import { Button, Container, createStyles, Group, Text } from "@mantine/core";
import React, { useState } from "react";
import { Icon } from "../../../custom-components/icons";
import Modal from "../../../custom-components/model";
import { User } from "../../../models/models";
import t from "../../../stores/language";
const useStyles = createStyles((theme) => ({
  deleteIconDiv: {
    fontSize: theme.fontSizes.md,
    flexWrap: "nowrap",
    marginBottom: theme.other.arc.margins[2],
  },

  deleteTextInputError: {
    fontSize: theme.fontSizes.sm,
  },
  deleteText: {
    textOverflow: "ellipsis",
    display: "block",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  modalFooter: {
    borderTop: "1px solid #ccc",
    padding: theme.other.arc.paddings[2],
    justifyContent: "end",
  },
}));
export const LockUserConfirmationModal = function LockUserConfirmationModal({
  item,
  onOk,
  onCancel,
  confirmText,
  visible,
}: {
  item: User | null;
  onOk: () => void;
  onCancel: () => void;
  confirmText?: string;
  visible: boolean;
}) {
  const [saving, setSaving] = useState<boolean>(false);
  const { classes } = useStyles();

  const lockUserCancel = () => {
    setSaving(false);
    visible = false;
    onCancel();
  };
  const lockUserConfirm = () => {
    setSaving(true);
    setSaving(false);
    visible = false;
    onOk();
  };

  return (
    <Modal
      opened={visible}
      header={t("Are You Sure ?")}
      footer={
        <Group className={classes.modalFooter}>
          <Button variant="default" onClick={lockUserCancel}>
            {t("No")}
          </Button>
          <Button color="red" onClick={lockUserConfirm} loading={saving}>
            {t("Yes")}
          </Button>
        </Group>
      }
      withCloseButton={true}
      onClose={lockUserCancel}
      size={500}
    >
      <Container p={"xs"}>
        <Group className={classes.deleteIconDiv}>
          <Icon size="lg" color="#faad14" icon={faExclamationCircle} />
          <Text lineClamp={2} className={classes.deleteText}>
            {confirmText ? confirmText + ". " : ""}
            {t(`Are you sure you want to lock, ${item?.name ?? ""} ?`)}
          </Text>
        </Group>
      </Container>
    </Modal>
  );
};
